<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">

    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">
      <z-page :title="title">
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <div  v-if="form.id == 0">
            <z-select style="margin:5px; " class="mt4"  :items="premis" label="ID / Nama Premis *"  v-model="form.premis_id" @input="getArtPermohonan()" :validators="[validators.required]"/>

            <z-select style="margin:5px; " class="mt4"  :items="art_permohonan" label="No. Permohonan *"  v-model="form.art_id" @input="getArtButiranKes()" :validators="[validators.required]"/>

            <z-select style="margin:5px; " class="mt4"  :items="art_butiran_kes" label="No Kes *"  v-model="form.id" @input="getData()" :validators="[validators.required]"  />
            </div>
             <div  v-if="form.id > 0">
               <table width="60%">
                <tbody>
                 <tr class="row_data">
                   <td  width="23%"><b>No Kes</b></td>
                   <td  width="2%"><b>:</b></td>
                   <td  width="35%">{{form.no_kes}}</td>
                </tr>
                <tr class="row_data">
                   <td><b>No Pendaftaran Induk</b></td>
                   <td><b>:</b></td>
                   <td>{{form.induk}}</td>
                </tr>
                <tr class="row_data">
                   <td><b>ID | Nama Induk</b></td>
                   <td><b>:</b></td>
                   <td>{{form.id_ternakan}} | {{form.nama_induk}}</td>
                </tr>
                <tr class="row_data">
                   <td><b>Generasi Induk</b></td>
                   <td><b>:</b></td>
                   <td>{{form.induk_gred}}</td>
                </tr>
                <tr class="row_data">
                   <td><b>Baka Induk</b></td>
                   <td><b>:</b></td>
                   <td>{{form.induk_baka}}</td>
                </tr>
                <tr class="row_data">
                   <td><b>ID Pejantan</b></td>
                   <td><b>:</b></td>
                   <td>{{form.pejantan}}</td>
                </tr>
                
                <tr class="row_data">
                   <td><b>Baka Pejantan</b></td>
                   <td><b>:</b></td>
                   <td>{{form.pejantan_baka}}</td>
                </tr>
                <tr class="row_data" v-if="form.penderma">
                   <td><b>ID Pederma</b></td>
                   <td><b>:</b></td>
                   <td>{{form.penderma}}</td>
                </tr>
                
                <tr class="row_data" v-if="form.penderma">
                   <td><b>Baka Pederma</b></td>
                   <td><b>:</b></td>
                   <td>{{form.penderma_baka}}</td>
                </tr>
                </tbody>
             </table>
              <w-input class="mt4" label="Tarikh Laporan *" type="date" v-model="form.tarikh_laporan" :validators="[validators.required]"/>
              <z-select style="margin:5px; " class="mt4"  :items="gred" label="Generasi Anak *"  v-model="form.lkp_gred_id"  :validators="[validators.required]" :disabled="form.se_stock_id" />
              <!-- <w-select style="margin:5px; " class="mt4"  :items="baka" label="Baka Anak *"  v-model="form.lkp_baka_id"  :validators="[validators.required]" :disabled="form.se_stock_id" /> -->
              <z-select style="margin:5px; " class="mt4"  :items="baka" label="Baka Anak *"  v-model="form.lkp_baka_id"  :validators="[validators.required]"/>
              <br>

               <w-select style="margin:5px;" class="mt4"  :items="Array.from({ length: 11 }, (_, i) => ({ value: i, label: String(i) }))" label="Bilangan Seperanakan *" v-model="form.bilangan_anak" :validators="[validators.required]" />

            <!--  <w-input
               class="mt4"
               label="Bilangan Seperanakan *"
               v-model.number="form.bilangan_anak"
               type="number"
               min="0"
               max="15"
               style="margin-top:-5px"
            /> -->
              <br>
              <br>
              
            </div>
          </div>
          <div class="mx2"></div>
          <div class="grow " >

            
            <!-- <div  v-if="form.id > 0">
              
             <vueper-slides fade :touchable="false" fixed-height="300px">
                <vueper-slide v-for="(slide, i) in slides"  :key="i"  :image="slide.image"  />
              </vueper-slides>
             <template v-if="$zutil.anyRole(['1', '2', '5'])">
                <w-input type="file" :preview="false" accept=" image/*" @input="uploadImg('\\App\\Model\\ArtButiran')" v-model="files" multiple>Muat Naik Gambar</w-input>
                <template v-for="dt, ind  in attahecment">
                  <div class="fw-normal my1 fs-1">  
                    <a :href="dt.url">{{ dt.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecment(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                  </div>
                </template>
              </template>
            </div>
            <br>

             <w-input
               class="mt4"
               label="Bilangan Seperanakan *"
               v-model.number="form.bilangan_anak"
               type="number"
               min="0"
               max="15"
               style="margin-top:-5px"
            /> -->
            <br>
          </div>
      </div>
      <div class="w-table w-table--wrap">
        <div class="w-table__scroll-wrap" >
          <table class="w-table" color="light" :key="load">
            <thead>
              <tr>
                <th class="w-table__header  text-left" width="1%">No</th>
                <th class="w-table__header  text-left" >Status Kelahiran *</th>
                <th class="w-table__header  text-left" >Tarikh *</th>
                <th class="w-table__header  text-left" >Catatan</th>
                <th class="w-table__header  text-left" >ID Ternakan</th>
                <th class="w-table__header  text-left" >Nama Ternakan</th>
                <th class="w-table__header  text-left" >Jantina *</th>
                <th class="w-table__header  text-left" >Kaedah Kelahiran *</th>
                <th class="w-table__header  text-left" >Berat Lahir (Kg)</th>
                <th class="w-table__header  text-left" >Warna Bulu</th>
                <th class="w-table__header  text-left" width="150px">Cacat</th>
                <th class="w-table__header  text-left" width="150px">Muat Naik</th>
                <!-- <th class="w-table__header  text-left"  width="1%"><w-icon class="mr1" @click="addItem">fal fa-plus</w-icon></th> -->
              </tr>
            </thead>

            <tbody v-if="form.bilangan_anak > 0">
              
              <template v-for="(dt, ind) in form.anak">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" >{{ind+1}}</td>
                  <td class="w-table__cell text-left" >
                    <z-select class="mt4"  :items="status_kelahiran"   v-model="dt.lkp_status_id"  style="margin-top:-5px"   :validators="[validators.required]" />
                  </td>
                  <td class="w-table__cell text-left" >
                    <w-input class="mt4" type="date"  v-model="dt.tarikh_lahir" style="margin-top:-5px" :validators="[validators.required]" />
                  </td>
                   <td class="w-table__cell text-left" >
                    <w-input class="mt4"  v-model="dt.nyatakan_kelahiran" style="margin-top:-5px" :validators="[validators.required]" v-if="dt.lkp_status_id == 7 || dt.lkp_status_id == 15"/>
                    <!-- <w-input class="mt4"  v-model="dt.nyatakan_kelahiran" style="margin-top:-5px" readonly v-else /> -->
                  </td>
                  <td class="w-table__cell text-left" >
                    <w-input class="mt4"  v-model="dt.id_anak" style="margin-top:-5px" />
                  </td>
                  <td class="w-table__cell text-left" >
                    <w-input class="mt4"  v-model="dt.nama" style="margin-top:-5px" />
                  </td>
                  <td class="w-table__cell text-left" >
                    <z-select  class="mt4"  :items="jantina"   v-model="dt.jantina"  style="margin-top:-5px"   :validators="[validators.required]" />
                  </td>
                  <td class="w-table__cell text-left" >
                    <z-select class="mt4"  :items="kaedah_kelahiran"   v-model="dt.lkp_kaedah_kelahiran_id"  style="margin-top:-5px"  :validators="[validators.required]" />
                  </td>
                  <td class="w-table__cell text-left" >
                    <w-input class="mt4"   v-model="dt.berat" type="number" style="margin-top:-5px"  />
                  </td>
                  <td class="w-table__cell text-left" >
                    <!-- <w-input class="mt4"   v-model="dt.warna_bulu"  style="margin-top:-5px"  /> -->
                    <z-select class="mt4"  :items="lkp_warna"   v-model="dt.lkp_warna_id"  style="margin-top:-5px"   />
                  </td>
                  <td class="w-table__cell text-left" >

                    <z-select class="mt4"  :items="cacat"   v-model="dt.cacat"  style="margin-top:-5px"   />
                    <w-input class="mt4"   v-model="dt.nyatakan_cacat"  style="margin-top:-5px"  v-if="dt.cacat == 2"/>
                  </td>
                  <td class="w-table__cell text-left" >
                      <!-- <w-input class="mt4" type="file" :preview="false" accept=" image/*" v-model="img" @input="Simpan()"  style="margin-top:-15px" multiple>Muat Naik Gambar</w-input> -->
                      <w-input class="mt4" type="file" :preview="false" accept=" image/*" v-model="img" @input="uploadImgAnak(dt.id)" style="margin-top:-15px" :validators="[validators.required]" multiple>Muat Naik Gambar</w-input>
                      

                          
                           <template v-for="d, ind  in dt.atthectment_image">
                                       <div class="fw-normal my1 fs-1">  
                                          <a :href="d.url">{{ d.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(d.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                                       </div>
                                    </template>
                  </td>
                  <!-- <td class="w-table__cell text-left" > -->
                  <!-- <w-icon class="mr1" @click="removeItem(index)">fal fa-trash</w-icon> -->
                  <!-- </td> -->
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '2', '5']) && form.lkp_status_id != 14 ">
           <w-button class="my1"   :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
                <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
            </w-button>
          &nbsp;
            <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
              <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
            </w-button>
        </w-flex>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
     </z-page>
    </w-form>
  </zen-one>
  
</template>



<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.anak',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pensijilan Ternakan Baka', route: '/art' },
        { label: 'Sijil Lahir', route: '/art/anak' },
        { label: 'Form', route: '/art/anak' },
      ],
      title : 'Permohonan Pembiakan Perkhidmatan',
      cacat : [
          {label : 'Tidak', value : 1},
          {label : 'Ya', value : 2}
        ],
      form : {
        id : this.id,
        premis_id : '',
        art_id : '',
        tarikh_lahir : '',
        lkp_kaedah_kelahiran_id : '',
        lkp_gred_id : '',
        tarikh_laporan: null,
        bilangan_anak : 0,
        lkp_status_anak_id : '',
        anak : [
          {
            id : '',
            nama : '',
            id_anak : '',
            jantina : '',
            jantina_label : '',
            berat : '',
            lkp_kaedah_kelahiran_id : '',
            kaedah_kelahiran_label : '',
            lkp_status_id : '',
            status_label : '',
            warna_bulu : '',
            lkp_warna_id : '',
            cacat : '',
            nyatakan_cacat : '',
            img:[],
          }
        ]
      },
      loading:false,
      premis : [],
      kaedah_kelahiran : [],
      status_kelahiran : [],
      art_butiran : [],
      gred : [],
      jantina : [],
      baka : [],
      lkp_warna : [],
      attahecment : [],
      slides : [],
      img:[],
      attahecmentImg:[],
      art_permohonan : [],
      art_butiran_kes : [],
      
      
    }
  },
  methods: {
    send(hantar){
      this.form.hantar = hantar
    },
    onSuccess(){
      if(this.form.hantar == 1){

       this.form.lkp_status_anak_id = 34

        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if(this.form.id){
                this.$zcomm.update(this.resourceurl + '.update_web', this.form.id, this.form)
                .then(res => {
                  // this.$inertia.visit(this.$route('art.anak.index'));
                  if(this.form.lkp_art_id==1){
                   this.$inertia.visit(this.$route('art.semakan.ai', this.form.art_id)+'?t=2');
                  }else if(this.form.lkp_art_id==2){
                   this.$inertia.visit(this.$route('art.semakan.pd', this.form.art_id)+'?t=2');
                  }else if(this.form.lkp_art_id==3){
                   this.$inertia.visit(this.$route('art.semakan.et', this.form.art_id)+'?t=2');
                  }else if(this.form.lkp_art_id==4){
                   this.$inertia.visit(this.$route('art.semakan.sinkronisasi', this.form.art_id)+'?t=2');
                  }
                  // this.$inertia.visit(this.$route('art.permohonan.show', this.form.art_id)+'?t=2');
                })
              }

            }
          })
      }else{
        if (this.form.id > 0) 
        {


         this.form.lkp_status_anak_id = 19
          
          this.$zcomm.update(this.resourceurl + '.update_web', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('art.anak.form', this.form.id));
           
          })
        }
        
      } 
    },

   Simpan()
   {
      if (this.form.id > 0) 
      {
         this.form.lkp_status_anak_id = 19
          
          this.$zcomm.updateNoNotif(this.resourceurl + '.update_web', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            
           
            // this.$zutil.notify("Berjaya ditambahkan", true);
            // this.$inertia.visit(this.$route('art.anak.form', this.form.id));
            this.loadData();
           
          })
        } 
    },
    
    addItem() {
      this.form.anak.push( 
        {
            id : '',
            id_anak : '',
            nama : '',
            jantina : '',
            jantina_label : '',
            berat : '',
            lkp_kaedah_kelahiran_id : '',
            kaedah_kelahiran_label : '',
            lkp_status_id : '',
            status_label : '',
            warna_bulu : '',
            lkp_warna_id : '',
            cacat : '',
            nyatakan_cacat : ''
          }
      );
    },

    removeItem(index) {
      this.form.anak.splice(index, 1);
    },
     getData(){
      if(this.form.id > 0){
        this.$zcomm.get(this.api_service + 'art/art_butiran/'+this.form.id, {}).then(res => {
          this.form = res
          // this.getArtButiran()
          this.form.anak = res.anak || []
          this.getArtPermohonan()
          this.getAttahecment()

            // if (Array.isArray(this.form.anak)) {
            //    this.form.anak.forEach(anak => {
            //       this.getAttahecmentImg(anak.id)
            //    })
            // }
        })
      }
    },
    getPremis(){
      this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
        this.premis = res
      })
    },
    // getArtButiran(){
    //   this.$zcomm.get(this.api_service + 'lookup/art_butiran/'+this.form.premis_id, {}).then(res => {
    //     this.art_butiran = res
    //   })
    // },

    getArtPermohonan(){
      this.$zcomm.get(this.api_service + 'lookup/art_permohonan/'+this.form.premis_id, {}).then(res => {
        this.art_permohonan = res
      })
    },

    getArtButiranKes(){
      this.$zcomm.get(this.api_service + 'lookup/art_butiran_kes/'+this.form.art_id, {}).then(res => {
        this.art_butiran_kes = res
      })
    },
    getKaedahKelahiran(){
      this.$zcomm.get(this.api_service + 'lookup/kaedah_kelahiran', {}).then(res => {
        this.kaedah_kelahiran = res
      })
    },
    getStatusKelahiran(){
      this.$zcomm.get(this.api_service + 'lookup/status_kelahiran', {}).then(res => {
        this.status_kelahiran = res
      })
    },
    getGred(){
      this.$zcomm.get(this.api_service + 'lookup/gred', {}).then(res => {
        this.gred = res
      })
    },
    getBaka(){
      this.$zcomm.get(this.api_service + 'lookup/baka_all', {}).then(res => {
        this.baka = res
      })
    },
    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = res
      })
    },
    getAttahecment()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.form.id, model : '\\App\\Model\\ArtButiran'}).then(res => {
        this.attahecment = res
        this.slides = [];
       for (var b in this.attahecment) {
          this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
       }
      })
    },

    // getAttahecmentImg(item)
    // {
    //   this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\ArtAnak'}).then(res => {
    //     this.attahecmentImg = res
    //     this.slides = [];
    //    for (var b in this.attahecmentImg) {
    //       this.slides.push({title: this.attahecmentImg[b].information, image: this.attahecmentImg[b].url})
    //    }
    //   })
    // },

    tutup(){
      // this.$inertia.visit(window.route('art.anak.index'));
      if(this.form.lkp_art_id==1){
       this.$inertia.visit(this.$route('art.semakan.ai', this.form.art_id)+'?t=2');
      }else if(this.form.lkp_art_id==2){
       this.$inertia.visit(this.$route('art.semakan.pd', this.form.art_id)+'?t=2');
      }else if(this.form.lkp_art_id==3){
       this.$inertia.visit(this.$route('art.semakan.et', this.form.art_id)+'?t=2');
      }else if(this.form.lkp_art_id==4){
       this.$inertia.visit(this.$route('art.semakan.sinkronisasi', this.form.art_id)+'?t=2');
      }
    },
    

    uploadImg(item) 
    {  
       let formData = new FormData();
       for (var b in this.files) 
       {
           formData.append("files["+b+"]", this.files[b].file);
       }
       formData.append("model",item);
       formData.append("model_id", this.form.id);
       this.$zcomm.post('attahecment.upload', formData)
           .then((res) => {
               this.getAttahecment();
           })
           .catch((err) => {})
           .finally(() => {});
   },

    uploadImgAnak(item) 
    {  
       let formData = new FormData();
       for (var b in this.img) 
       {
           formData.append("files["+b+"]", this.img[b].file);
       }
       formData.append("model",'\\App\\Model\\ArtAnak');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload', formData)
           .then((res) => {
               // this.getAttahecmentImg(item);
               this.onSuccess();
               this.loadData();
           })
           .catch((err) => {})
           .finally(() => {
            
           });
   },
   
   deletelAttahecment(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
       })
     }
   },

   deletelAttahecmentImg(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        // this.getAttahecmentImg();
         this.loadData();
       })
     }
   },
//     async deletelAttahecmentImg(id) {
//   if (confirm('Are you sure to delete this record?')) {
//     try {
//       await this.$zcomm.get(this.$route('attahecment.delete', id));
//       await this.loadData(); // reload
//     } catch (err) {
//       console.error('Gagal delete attachment:', err);
//     }
//   }
// },

// async loadData() {
//   if (this.form.id > 0) {
//     const res = await this.$zcomm.get(this.api_service + 'art/art_butiran/' + this.form.id, {});
//     Object.assign(this.form, res); // ⚡ reactive update
//     this.load++;
//   }
// },


    getWarna(){
         this.$zcomm.get(this.api_service + 'lookup/warna', {}).then(res => {
           this.lkp_warna = res
         })
       },

   loadData() {
      if(this.form.id > 0){
         this.$zcomm.get(this.api_service + 'art/art_butiran/'+this.form.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1
        })
      }


    },




  },

  
 watch: {
  'form.bilangan_anak'(newVal) {
    // Validasi
    if (newVal < 0) newVal = 0;
    if (newVal > 10) newVal = 10;

    this.form.bilangan_anak = newVal;
    const currentCount = this.form.anak.length;

    // ==============================
    // 1) Bila bilangan_anak = 0
    // ==============================
    if (newVal === 0) {
      // kosongkan semua anak
      this.form.anak = [];

      // simpan perubahan (hapus semua anak)
      this.Simpan();
      return;
    }

    // ==============================
    // 2) Tambah anak
    // ==============================
    if (newVal > currentCount) {
      for (let i = currentCount; i < newVal; i++) {
        this.form.anak.push({
          id: '',
          id_anak: '',
          nama: '',
          jantina: '',
          jantina_label: '',
          berat: '',
          lkp_kaedah_kelahiran_id: '',
          kaedah_kelahiran_label: '',
          lkp_status_id: '',
          status_label: '',
          warna_bulu: '',
          lkp_warna_id: '',
          cacat: '',
          nyatakan_cacat: '',
          nyatakan_kelahiran: '',
          tarikh_lahir: '',
          files: []
        });
      }
      this.Simpan();
      return;
    }

    // ==============================
    // 3) Kurangkan anak (tetapi > 0)
    // ==============================
    if (newVal < currentCount) {
      this.form.anak.splice(newVal);
      this.Simpan();
    }
  }
},
  mounted() {
    this.getData()
    this.getPremis()
    this.getKaedahKelahiran()
    this.getStatusKelahiran()
    this.getGred()
    this.getBaka()
    this.getJantina()
    this.getWarna()
    if(this.id > 0)
    {
      this.title = 'Kemaskini Rekod Kelahiran Anak AI/ET'
    }
    else
    {
      this.title = 'Tambah Rekod Kelahiran Anak AI/ET'
    }
    
  }
    
}
</script>
